var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"bf-button actionable component",attrs:{"unselectable":"on","type":_vm.type,"title":_vm.title,"disabled":_vm.disabled}},[_vm._t("icon"),_vm._t("text")],2)}
var staticRenderFns = []

export { render, staticRenderFns }